import { render, staticRenderFns } from "./CustomerCasesView.vue?vue&type=template&id=64f82ebc&"
import script from "./CustomerCasesView.vue?vue&type=script&lang=js&"
export * from "./CustomerCasesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports